import ui from "react-components";
import React from "react/addons";
window.top.molgenis = window.top.molgenis || {};
window.top.molgenis.ui = ui;
window.top.React = React;


// WEBPACK FOOTER //
// ./src/main/javascript/molgenis-global-ui-webpack.js